export const EventType = {
  PARTY: 'Party',
  IN_PERSON_EVENT: 'In-Person Event',
  FACEBOOK_PARTY: 'Facebook Party',
  WHATS_APP_PARTY: 'WhatsApp Party',
} as const

export type EventTypeType = typeof EventType[keyof typeof EventType]

export function getEventTypeLabelKey(eventType: string): string {
  const map: Record<string, string> = {
    [EventType.PARTY]: 'eventTypes.Party',
    [EventType.IN_PERSON_EVENT]: 'eventTypes.InPersonEvent',
    [EventType.FACEBOOK_PARTY]: 'eventTypes.FacebookParty',
    [EventType.WHATS_APP_PARTY]: 'eventTypes.WhatsAppParty',
  }
  return map[eventType] ?? 'eventTypes.Unknown'
}
